<template>
  <section class="blog-section">
    <div class="blog-header">
      <span class="eyebrow">Union Ocean Blog</span>
      <h1>教育專欄</h1>
      <p>
        分享英語教材選書、雙語教學趨勢與閱讀推廣方法，
        陪伴老師與學校找到更適合學生的學習資源。
      </p>
    </div>

    <div class="blog-grid">
      <RouterLink
        v-for="post in posts"
        :key="post.id"
        :to="`/Blog/${post.id}`"
        class="blog-card"
      >
        <img :src="post.cover" :alt="post.title" />

        <div class="blog-content">
          <span>{{ post.category }}</span>

          <h2>{{ post.title }}</h2>

          <p>{{ post.excerpt }}</p>

          <div class="read-more">閱讀更多 →</div>
        </div>
      </RouterLink>
    </div>
  </section>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { getBlogPosts } from "@/api/blogApi";

const posts = ref([]);

onMounted(async () => {
  const data = await getBlogPosts();

  posts.value = data.filter((item) => item.status === "active");
});
</script>

<style scoped>
.blog-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 36px;
  max-width: 980px;
  margin: 56px auto 0;
}

.blog-card {
  display: block;
  background: #ffffff;
  border-radius: 24px;
  overflow: hidden;
  text-decoration: none;
  color: inherit;
  box-shadow: 0 18px 45px rgba(0, 72, 155, 0.12);
  transition: 0.3s ease;
}

.blog-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 24px 56px rgba(0, 72, 155, 0.18);
}

.blog-card img {
  display: block;
  width: 100%;
  height: 220px;
  object-fit: cover;
  background: #eef5ff;
}

.blog-card-body,
.blog-content {
  padding: 28px 30px 32px;
  text-align: left;
}

.blog-card-body span,
.blog-content span {
  display: inline-block;
  margin-bottom: 14px;
  color: #005eb8;
  font-size: 14px;
  font-weight: 700;
}

.blog-card-body h2,
.blog-content h2 {
  font-size: 24px;
  line-height: 1.45;
  color: #102a43;
  margin: 0 0 16px;
  letter-spacing: 0.02em;
}

.blog-card-body p,
.blog-content p {
  color: #5f6f82;
  line-height: 1.8;
  margin: 0;
  font-size: 16px;
}

.read-more {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-top: 24px;
  color: #005eb8;
  font-weight: 700;
}

@media (max-width: 900px) {
  .blog-grid {
    grid-template-columns: 1fr;
    max-width: 520px;
    gap: 28px;
  }

  .blog-card img {
    height: 200px;
  }
}
</style>
